import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  width: 604px;
  border: 2px solid black;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 2px solid black;
`;

export const TitleWrapper = styled.div`
  font-size: 24px;
  display: flex;
  align-items: center;
  width: 345px;
  padding: 8px 0;
  border-right: 1px solid black;
  font-weight: 500;
`;

export const ImageWrapper = styled.div`
  padding: 8px 0;
  border-left: 1px solid black;
`;

export const BodyWrapper = styled.div``;

export const ContentWrapper = styled.div`
  border-left: 1px solid black;
  border-right: 1px solid black;
  height: 100%;
  width: 520px;
  margin: 0 auto;
`;

export const TextWrapper = styled.div`
  padding: 40px 24px;
`;

export const BottomLine = styled.div`
  border-top: 1px solid black;
  padding-bottom: 32px;
`;
